var exports = {
  "ox": "x43aef4ae--bbad2a--common-title-col",
  "e1": "x43aef4ae--bbad2a--common-rate-col",
  "Lt": "x43aef4ae--bbad2a--common-sum-col",
  "yB": "x43aef4ae--bbad2a--common-term-col",
  "Ci": "x43aef4ae--bbad2a--common-payment-col",
};

module.exports = exports;
